import { render, staticRenderFns } from "./VideoAutoplay.vue?vue&type=template&id=63ee10d8&scoped=true&"
import script from "./VideoAutoplay.vue?vue&type=script&lang=js&"
export * from "./VideoAutoplay.vue?vue&type=script&lang=js&"
import style0 from "./VideoAutoplay.vue?vue&type=style&index=0&id=63ee10d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ee10d8",
  null
  
)

export default component.exports